import { VideoFragment } from '@lib/umbraco/generated/types.generated'

export interface ISublimeVideoLoader {
  videoLoader: () => string
  posterLoader: () => string
}
const deviceSizes = [640, 750, 828, 1080, 1200, 1440, 1920]

export class SublimeVideoLoader implements ISublimeVideoLoader {
  private internVideo: VideoFragment
  private width: number

  constructor(mediaPicker: VideoFragment, width: number) {
    this.internVideo = mediaPicker
    this.width = deviceSizes.reduce((prev, curr) =>
      Math.abs(curr - width) < Math.abs(prev - width) ? curr : prev,
    )
  }

  posterLoader() {
    let posterUrl = ''
    if (this.internVideo.thumbnailImage?.media?.id) {
      posterUrl = `https://${process.env
        .NEXT_PUBLIC_CLOUDFRONT_DISTRO!}.cloudfront.net/${
        this.internVideo?.thumbnailImage.media.id
      }-${this.width}.webp`
    } else {
      // posterUrl = `https://media.gubi.com/${this.internVideo?.id.replaceAll(
      //   '-',
      //   ''
      // )}.webp`
    }

    return posterUrl
  }
  videoLoader() {
    return `https://media.gubi.com/${this.internVideo?.id}.mp4`
  }
}
